<script>
  import Layout from '../components/Layout.svelte';
  import WebhookEventNotification from '../components/WebhookEventNotification.svelte';
  import ModuleMenu from '../components/ModuleMenu.svelte';
</script>

<Layout activeRoute="dashboard">
  <div class="container mx-auto px-4 py-5 sm:py-8">
    <!-- Compact auto-sync bar sits at the very top -->
    <WebhookEventNotification />

    <!-- Module cards are the mobile nav; desktop already has the sidebar. -->
    <div class="md:hidden">
      <h1 class="text-xl font-semibold text-gray-900 mb-4">Select a Function</h1>
      <ModuleMenu />
    </div>
  </div>
</Layout>
